import React from 'react';
import { Content, Header } from './styles';
import Footer from '~/Components/Footer';
import { Table } from 'reactstrap';
import FileFtp from '~/Components/FileFtp';

function Metadados() {
	let links = [
		{
			"name":"Metadados",
			"files": [
				{
					"url":"http://www.prefeituradivinopolis.com.br/geoplantas/metadados/",
					"description":"Metadados",
					"name":"metadados",
					"originalName":"Metadados",
					"ext":"ftp"
				}
			]
		}
	];

	return (
		<>
			<Content>
				<Header>METADADOS</Header>
				<p>
					Metadados são informações de determinado dado. Os metadados
					são essenciais para organização e classificação de conjuntos
					de dados. Contemplam informações como: título, nome do
					arquivo, tipo de arquivo, geometria, escala de vetorização,
					Datum, Fuso UTM
				</p>
				{/* <p style={{ color: 'red' }}>
					<b>Seção temporariamente indisponível</b>
				</p> */}

				<Table hover>
					<tbody>
						{links.map((e, i) => (
							<FileFtp key={String(i)} data={e} />
						))}
					</tbody>
				</Table>
			</Content>
			<Footer />
		</>
	);
}

export default Metadados;
